var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actions-page",style:({overflowY: 'auto'}),attrs:{"id":"scroll-container"}},[(_vm.isLoading)?_c('Loading'):(_vm.error)?_c('Error',{attrs:{"error":_vm.error}}):_c('ActionsContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }